import { render, staticRenderFns } from "./SelecaoMaterial.vue?vue&type=template&id=2eda7b1c&"
import script from "./SelecaoMaterial.vue?vue&type=script&lang=js&"
export * from "./SelecaoMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports